import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'

@Component({
  selector: 'gb-presenter-tools-elevation',
  imports: [MatTooltipModule, MatIconModule, MatButtonModule],
  templateUrl: './gb-presenter-tools-elevation.component.html',
  styleUrl: './gb-presenter-tools-elevation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterToolsElevationComponent {
  @Output() bringToFront = new EventEmitter<void>()
  @Output() bringForward = new EventEmitter<void>()
  @Output() sendBackward = new EventEmitter<void>()
  @Output() sendToBack = new EventEmitter<void>()

  onBringToFront(): void {
    this.bringToFront.emit()
  }

  onBringForward(): void {
    this.bringForward.emit()
  }

  onSendBackward(): void {
    this.sendBackward.emit()
  }

  onSendToBack(): void {
    this.sendToBack.emit()
  }
}
